import React, { useEffect, useState } from 'react'
import { FormContext, useForm } from 'react-hook-form'
import { Card, CardActions, CardContent, Grid, TableCell, TableRow } from 'react-md'
import { format, parseISO } from 'date-fns'

import { ClientAutoComplete, TechnicianAutoComplete } from 'components/auto-complete'
import { handleSubmit, InputDatePicker, InputNumber, Select } from 'components/form'
import { ConfirmDialog, Cell, PageTitle, ButtonSearch } from 'components/core'
import { DataTable, DeleteButton, EditButton } from 'components/data-table'
import { DataTableResult } from 'components/data-table/types'

import { getTechnicalVisitStatusDescription, TechnicalVisitStatusOptions } from 'types/technical-visit/technical-visit'

import { handleSearch, handleEdit, handleDelete } from './actions'
import { defaultValues, validationSchema } from './config'

const Component: React.FC = () => {
  const form = useForm({ defaultValues })
  const [filter, setFilter] = useState<any>()
  const [result, setResult] = useState<DataTableResult>({ total: 0, results: [] })
  const [deleteId, setDeleteId] = useState<string>()
  const [toogleUpdate, setToogleUpdate] = useState<boolean>(false)

  useEffect(() => {
    document.title = 'Pesquisa de Visita Técnica'
  }, [])

  return (
    <>
      <Grid>
        <Cell>
          <PageTitle title='Pesquisa de Visita Técnica' />
          <Card fullWidth>
            <CardContent>
              <FormContext {...form}>
                <Grid>
                  <InputNumber name='number' label='Número' desktopSize={3} tabletSize={2} />
                  <ClientAutoComplete name='client' label='Cliente' desktopSize={3} tabletSize={8} />
                  <TechnicianAutoComplete name='technician' label='Técnico' desktopSize={3} tabletSize={8} />
                  <Select name='technicalVisitStatus' label='Status' options={TechnicalVisitStatusOptions} desktopSize={3} tabletSize={4} />
                  <InputDatePicker name='initialVisitDate' label='Data de Visita Inicial' desktopSize={3} tabletSize={4} />
                  <InputDatePicker name='finalVisitDate ' label='Data de Visita Final' desktopSize={3} tabletSize={4} />
                </Grid>
              </FormContext>
              <CardActions>
                <ButtonSearch onClick={async () => await handleSubmit(form, validationSchema, () => setFilter(form.getValues()))} />
              </CardActions>
            </CardContent>
          </Card>
        </Cell>
        <Cell>
          <DataTable
            filter={filter}
            header={[
              { order: 'Id', label: 'Número' },
              { label: 'Cliente' },
              { label: 'Técnico' },
              { label: 'Status' },
              { order: 'VisitDate', label: 'Data da Visita' },
              { label: '' },
            ]}
            result={result}
            setResult={setResult}
            search={handleSearch}
            update={toogleUpdate}
            total={result ? result.total : 0}>
            {result &&
              result.results &&
              result.results.map((data: any, index) => (
                <TableRow key={index}>
                  <TableCell>{data.number}</TableCell>
                  <TableCell>{data.clientFantasyName}</TableCell>
                  <TableCell>{data.technicianName}</TableCell>
                  <TableCell>{getTechnicalVisitStatusDescription(data.technicalVisitStatus)}</TableCell>
                  <TableCell>{format(parseISO(data.visitDate), "dd'/'MM'/'yyyy")}</TableCell>
                  <TableCell align='right'>
                    <EditButton id={`edit-${index}`} action={() => handleEdit(data.id)} />
                    <DeleteButton id={`delete-${index}`} action={() => setDeleteId(data.id)} />
                  </TableCell>
                </TableRow>
              ))}
          </DataTable>
        </Cell>
      </Grid>
      <ConfirmDialog
        text='Deseja realmente excluir a visita técnica? Essa ação não poderá ser desfeita'
        visible={deleteId ? true : false}
        confirmAction={async () => {
          if (deleteId) if (await handleDelete(deleteId)) setToogleUpdate(!toogleUpdate)
          setDeleteId(undefined)
        }}
        cancelAction={async () => setDeleteId(undefined)}
      />
    </>
  )
}

export default Component
